export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtVyskaPneu';
export const NAME = 'VyskaPneu';
